import React from 'react';
import './App.css';
import data from './content/Program.json';

function Program() {
  
  return (
    <div className="App">
    <div className="landing">
      <div className="landing-content-wrapper">
        <div className="landing-text-wrapper">
          <h2 className="landing-text-title">
            {data.Landing.title}
          </h2>
         
          <div className="landing-text-description">
            {data.Landing.text}
          </div>
        </div>
        <div className="landing-graphic-container">
          <img className="landing-graphic" src={data.Landing.image} alt="an image"/>
        </div>
      </div>
    </div>

    {data.sections.map(idx => (
            <div className="content">
            <div className="content-wrapper">
              <div className="content-text-wrapper">
                <div className="content-text-heading">
                  <h3>{idx.heading}</h3>
                </div>
                <div className="content-text-description">
                  <p>{idx.text}</p>
                  <hr/>
                </div>
              </div>
              
                <div className="image-placeholder">
                  <img  src={idx.image} className="content-image" alt="image here"/>
                </div>
            </div>
          </div>
          ))}
          
    </div>
  );
}

export default Program;
